import {
  Component,
  EventEmitter,
  inject,
  input,
  type OnChanges,
  Output,
  type SimpleChanges,
} from '@angular/core';
import { TranslateService } from '@fino-ui/translation';
import * as Highcharts from 'highcharts';
import { HighchartsChartComponent } from 'highcharts-angular';
import { map } from 'lodash';
import { TicketOverviewService } from '../ticket-overview.service';
import { chart } from './ticket-overview.chart';

@Component({
  selector: 'app-ticket-overview-chart',
  templateUrl: './ticket-overview-chart.component.html',
  imports: [HighchartsChartComponent],
})
export class TicketOverviewChartComponent implements OnChanges {
  private readonly translateService = inject(TranslateService);
  private readonly ticketOverviewService = inject(TicketOverviewService);

  updateFlag: boolean = false;

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = chart;

  public selectedTicketType: boolean | string = false;
  public blacklistStatus: string[] = [];

  public readonly statistic = input<any>(undefined);

  @Output()
  public legendClicked = new EventEmitter();

  ngOnChanges(changes: SimpleChanges) {
    const { statistic } = changes;
    if (statistic) {
      this.updateFlag = false;

      const series = this.ticketOverviewService.calcChartSeries(
        this.statistic(),
      );
      this.chartOptions.series = series;

      this.chartOptions.plotOptions.series.events.legendItemClick =
        this.legendClickEvent.bind(this);

      const translateService = this.translateService;

      this.chartOptions.legend.labelFormatter = function () {
        return translateService.instant(`app.ticket.status.${this.name}`);
      };

      this.chartOptions.tooltip.formatter = function () {
        return `${translateService.instant(
          `app.ticket.status.${this.series.name}`,
        )}: <b>${this.y}</b>`;
      };

      this.updateFlag = true;
    }
  }

  legendClickEvent(event: any) {
    this.blacklistStatus = [];
    const { chart } = event.target;
    if (event.target.name !== this.selectedTicketType) {
      map(chart.series, (i) => {
        if (i.name !== event.target.name) {
          i.hide();
          this.blacklistStatus.push(i.name);
        } else {
          i.show();
        }
      });
      this.selectedTicketType = event.target.name;
    } else {
      map(chart.series, (i) => {
        i.show();
      });
      this.selectedTicketType = false;
    }
    this.legendClicked.next(this.blacklistStatus);
    return false;
  }
}
